/* CycloOutlet V128 — comparador móvil y búsqueda semántica */
(() => {
  'use strict';
  const normalize = value => String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase().replace(/\s+/g,' ').trim();
  const initMiniCompare = () => {
    document.querySelectorAll('[data-product-mini-comparator]').forEach(root => {
      const button = root.querySelector('[data-v128-mini-compare-toggle]');
      if (!button || button.dataset.ready === 'true') return;
      button.dataset.ready = 'true';
      button.addEventListener('click', () => {
        const expanded = root.classList.toggle('is-expanded');
        button.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        const label = button.querySelector('span');
        const icon = button.querySelector('b');
        if (label) label.textContent = expanded ? 'Ocultar comparación' : 'Comparar en esta ficha';
        if (icon) icon.textContent = expanded ? '−' : '+';
      });
    });
  };
  const destinationFor = raw => {
    const q = normalize(raw);
    if (!q) return '';
    if (q.includes('r7170') || (q.includes('105') && q.includes('di2'))) return '/collections/shimano-105?co_search=r7170#productos-filtrados';
    if (q.includes('105') && (q.includes('12v') || q.includes('12 velocidades'))) return '/collections/shimano-105?co_search=12#productos-filtrados';
    if (q.includes('grupo completo') || q === 'grupos' || q === 'grupo') return '/collections/grupos-completos#productos-filtrados';
    if (q.includes('pacha') || q.includes('cassette') || q.includes('casete')) {
      const term = q.includes('dura') ? 'dura' : q.includes('ultegra') ? 'ultegra' : q.includes('105') ? '105' : '';
      return '/collections/pachas' + (term ? '?co_search=' + encodeURIComponent(term) : '') + '#productos-filtrados';
    }
    if (q.includes('tensor') || q.includes('cambio trasero') || q.includes('rear derailleur')) {
      const term = q.includes('dura') ? 'dura' : q.includes('ultegra') ? 'ultegra' : q.includes('105') ? '105' : '';
      return '/collections/tensor-ultegra-r8000-gs' + (term ? '?co_search=' + encodeURIComponent(term) : '') + '#productos-filtrados';
    }
    if (q.includes('maneta') || q.includes('ergopower') || q.includes('shifter')) {
      const term = q.includes('dura') ? 'dura' : q.includes('ultegra') ? 'ultegra' : q.includes('105') ? '105' : '';
      return '/collections/manetas-ergopowers' + (term ? '?co_search=' + encodeURIComponent(term) : '') + '#productos-filtrados';
    }
    return '';
  };
  const initSearch = () => {
    document.querySelectorAll('[data-co-header-product-search]').forEach(form => {
      if (form.dataset.v128Ready === 'true') return;
      form.dataset.v128Ready = 'true';
      form.addEventListener('submit', event => {
        const input = form.querySelector('[data-co-header-product-search-input]');
        const destination = destinationFor(input?.value);
        if (!destination) return;
        event.preventDefault();
        window.location.assign(destination);
      });
    });
  };
  const init = () => { initMiniCompare(); initSearch(); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true});
  else init();
})();